import React from 'react'

const Skills = () => {
    return (
        <div className='pick'>
            <h2 className='h2Title'>Skills</h2>
            <h3 className='SkillTitle'>
                <p>
                    Designed many apps for homework and web pages.
                     <li>
                        Created this basic CV and other personal projects as well</li>
                    <li>Learned HTML, CSS, LESS, JSX, React, more skills to learn</li>
                </p>
                <p>
                    Highly Profecient and skilled in Microsoft Excel
                    <li>Placed State fifth place in a high school FBLA competition</li>
                    <li>Created a College Gradebook system for Rexburg College of Massage Therapy</li>
                </p>
                <p>
                    Lots of Experience in working with lots of Diverse population
                     <li>Working with Chinese tour groups that were staing at Super 8 heading to Yellow Stone park</li>
                </p>
                <p>
                    Lots of Eperience cleaning
                      <li>
                        Working at Deseret Industries cleaning bathrooms, and sales floor (if needed) and water fountains
                      </li>
                    <li>Cleaned Apartments and became a Team Lead for a group multiple times
                    </li>
                </p>
                <p>
                    Customer Service Experience of at least 6 years
                      <li>
                        Much prefer working with guests or customers in person rather than in a warehouse or on phone calls
                      </li>
                </p>
                <p>
                    Leadership Roles
                     <li>
                        Became a Team Lead for groups when working for Nauvoo House apartments.
                     </li>
                    <li>
                        Led many teams and a Guild in some video games
                    </li>
                </p>

            </h3>


        </div>
    )
}

export default Skills
